import { getPrimus } from '~/utils/primus';
import { CLIENT_ORIGIN_WS_EVENTS } from '~/constants';

export const updateMediaSettings = ({ userId, media_expire_time_settings }) => {
  const primus = getPrimus();

  const payload = {
    _id: userId,
    config: { media_expire_time_settings },
  };

  primus.emit(CLIENT_ORIGIN_WS_EVENTS.COLLECTION, { cid: 'users' }, payload);
};
